{
	"action": {
		"notification_broadcast_send": "Notifica inviata",
		"operator_activated": "Utente attivato",
		"operator_deactivated": "Utente disattivato",
		"operator_invitation_email_changed": "Email dell'invito utente modificata",
		"operator_invitation_resent": "Invito utente reinviato",
		"operator_invitation_revoked": "Invito utente revocato",
		"operator_invited": "Utente invitato",
		"operator_reactivated": "Utente riattivato",
		"operator_removed": "Utente rimosso",
		"organization_created": "Organizzazione creata",
		"organization_reactivated": "Organizzazione riattivata",
		"organization_storage_destroyed": "Organizzazione eliminata",
		"organization_suspended": "Organizzazione sospesa",
		"user_invite_resent": "Invito reinviato",
		"user_invited": "Invito inviato",
		"user_mfa_reset": "Reset 2FA"
	},
	"columns": {
		"action": "Azione",
		"admin": "Admin",
		"detail": "Dettaglio",
		"organization": "Organizzazione",
		"timestamp": "Data e ora"
	},
	"detail": {
		"failure_code": "Codice: {{code}}",
		"invite_resent": "Invio n. {{count}}",
		"storage_destroyed": "File e cartelle: {{nodes}} · Versioni: {{versions}}"
	},
	"empty": {
		"description": "Appena succede qualcosa in questa console compare qui, dal più recente.",
		"no_matches_description": "Nessuna azione corrisponde ai filtri attivi.",
		"no_matches_title": "Nessun risultato",
		"title": "Non è ancora stato registrato niente"
	},
	"filters": {
		"action": "Azione",
		"organization": "Organizzazione",
		"organization_placeholder": "Cerca organizzazione",
		"organization_unknown": "Organizzazione sconosciuta",
		"period": "Periodo"
	},
	"no_value": "Non disponibile",
	"outcome": {
		"failure": "Non riuscita"
	},
	"page_title": "Audit log"
}
